// Styles
import styles from './Text.module.sass'

// Interfaces
import { Colors } from '@interfaces/theme'

interface SpanProps {
  children: React.ReactNode
  decoration?: 'underline' | 'lineThrough'
  color?: Colors
}

const Span = ({ children, color, decoration }: SpanProps) => {
  return (
    <span
      className={`
        ${color ? styles[`text-${color}`] : ''}
        ${decoration ? styles[`text-${decoration}`] : ''}  
    `}
    >
      {children}
    </span>
  )
}

export default Span
